import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import AccountButton from './AccountButton';

class RegisterButton extends Component {

    handleRegister = () => {
        this.props.history.push(`/register`);
    }

    render() {
        const { classes } = this.props;

        return (
            <div style={{ backgroundColor: this.props.color }} className={classes.container}>
                {!this.props.user.first_name && (
                    <Button
                        onClick={this.handleRegister}
                        variant="contained"
                        className={classes.registerButton}
                    >
                        Register
                    </Button>
                )}
                {this.props.user.first_name && (
                    <AccountButton firstName={this.props.user.first_name} />
                )}
            </div>
        );
    }

}

const styles = theme => ({
    container: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
        padding: theme.spacing(0.5, 1),
    },
    registerButton: {
        borderRadius: 999,
        textTransform: 'none',
        fontWeight: 700,
        padding: theme.spacing(0.8, 2.4),
        color: theme.palette.common.white,
        backgroundImage: 'linear-gradient(135deg, #34d399, #10b981)',
        boxShadow: '0 10px 20px rgba(16, 185, 129, 0.35)',
        transition: 'transform 0.15s ease, box-shadow 0.15s ease',
        '&:hover': {
            backgroundImage: 'linear-gradient(135deg, #2ecf8d, #0f9f76)',
            transform: 'translateY(-1px)',
            boxShadow: '0 14px 24px rgba(16, 185, 129, 0.4)',
        },
    },
});

const mapStateToProps = state => ({
    user: state.user,
});

export default withRouter(
    connect(mapStateToProps)(withStyles(styles)(RegisterButton))
);
